import React from 'react';
import { NavLink } from 'react-router-dom';
import { usePermissions } from '../context/PermissionContext';
import { useLanguage, t } from '../context/LanguageContext';

const TABS = [
  { labelEn: 'Employees',    labelEs: 'Empleados',          path: '/admin/time-tracking',                module: 'time.tracking.manage', exact: true },
  { labelEn: 'Timecards',    labelEs: 'Tarjetas de Tiempo', path: '/admin/time-tracking/timecards',      module: 'time.tracking.view' },
  { labelEn: 'Reports',      labelEs: 'Reportes',            path: '/admin/time-tracking/reports',        module: 'time.tracking.reports' },
  { labelEn: 'Time Off',     labelEs: 'Días Libres',         path: '/time-tracking/time-off',             module: 'time.tracking.time_off' },
  { labelEn: 'PTO Requests', labelEs: 'Solicitudes',         path: '/time-tracking/pto-requests',         module: 'time.tracking.time_off' },
  { labelEn: 'Year-End',     labelEs: 'Fin de Año',          path: '/time-tracking/year-end-bonus',       module: 'time.tracking.manage' },
];

const STICKY = {
  position: 'sticky',
  top: 56,
  zIndex: 10,
  background: '#fff',
  borderBottom: '1px solid #dee2e6',
  paddingTop: 12,
  paddingBottom: 0,
  marginBottom: 0,
};

export default function TimeTrackingNav() {
  const { hasModule } = usePermissions();
  const { lang } = useLanguage();
  const visible = TABS.filter(tab => hasModule(tab.module));
  if (visible.length === 0) return null;
  return (
    <div style={STICKY}>
      <h3 className="mb-2">{t('Time Tracking', 'Control de Tiempo', lang)}</h3>
      <ul className="nav nav-tabs">
        {visible.map(tab => (
          <li key={tab.path} className="nav-item">
            <NavLink
              to={tab.path}
              end={tab.exact}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              {t(tab.labelEn, tab.labelEs, lang)}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
